import { render } from "./DashboardPointBreakdown.vue?vue&type=template&id=3288908e"
import script from "./DashboardPointBreakdown.vue?vue&type=script&lang=js"
export * from "./DashboardPointBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__